// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_ddo","colMin":"styles_colMin__1TCrM"};